import useSWR from 'swr';

import { CameraApiEnum } from 'src/models/Camera/AxiosInstance';
import CameraConnection from 'src/models/Camera/CameraConnection';

export function useGetCurrentCaptureProcess() {
  const { data, error, isLoading } = useSWR(
    CameraApiEnum.GET_CURRENT_CAPTURE_PROCESS,
    () => CameraConnection.getInstance().getCurrentCaptureProcess(),
    {
      refreshInterval: 1000,
      refreshWhenHidden: true,
    },
  );

  return {
    currentCaptureProcess: data?.data,
    isLoading,
    error,
  };
}
